module.exports = __webpack_public_path__ + "static/media/EXPORT_BULK_UPLOAD_ATHENA_WITHOUT_VAT_PARTNER.17c561fa.xlsx";